module.exports = __webpack_public_path__ + "img/goods02.0112f2f7.jpg";